
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AboutButton extends Vue {
  isDialogOpen = false;

  closeDialog() {
    this.isDialogOpen = false;
  }
}
